import { useState } from 'react';

export function useCourseSync(actions, app) {
  const [loading, setLoading] = useState(false);

  const [addedCourses, setAddedCourses] = useState([]);
  const [updatedCourses, setUpdatedCourses] = useState([]);
  const [unlinkedCourses, setUnlinkedCourses] = useState([]);
  const [fullCourses, setFullCourses] = useState([]);

  const fetchCompareData = async () => {
    setLoading(true);
    try {
      const res = await actions.compareCourseChanges(app);

      setAddedCourses(res.newCourses);
      setUpdatedCourses(res.updatedCourses);
      setUnlinkedCourses(res.unLinkedCourses);
      setFullCourses(res.fullCourses);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  return {
    loading,
    addedCourses,
    updatedCourses,
    unlinkedCourses,
    fullCourses,
    fetchCompareData,
  };
}
